/* eslint-disable import/first */
// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
import sanitizeRedirectLocation from 'helpers/sanitizeRedirectLocation';
export var LoginRoute = function LoginRoute(store) {
  return {
    path: '/login',
    onEnter: function onEnter(nextState, replaceState, cb) {
      // there are instances where we want the user to remain in the login screen
      if (store.getState().user.loggedIn && !nextState.location.query.noRedirect) {
        if (nextState.location.query && nextState.location.query.returnTo) {
          replaceState(sanitizeRedirectLocation(nextState.location.query.returnTo));
        } else if (nextState.params && nextState.params.splat) {
          replaceState(sanitizeRedirectLocation(nextState.params.splat));
        } else {
          replaceState('/');
        }
      }

      cb();
    },
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          component: require('features/Login/LoginContainer').LoginContainer
        });
      }, 'login');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: '*',
          component: require('features/Login/LoginContainer').LoginContainer
        }, {
          path: '**/*',
          component: require('features/Login/LoginContainer').LoginContainer
        }]);
      }, 'login');
    }
  };
};